import i18n from "@/config/i18n";
/**
 * 时间转时间戳
 * @param strTime yyyy-MM-dd HH:MM:SS
 * @returns 10位数时间戳
 */
export const piThTimeStrto = (strTime) => {
    let newStr = strTime.replace(/:/g, "-");
    newStr = newStr.replace(/ /g, "-");
    const arr = newStr.split("-");
    const datum = new Date(Date.UTC(parseInt(arr[0]), parseInt(arr[1]) - 1, parseInt(arr[2]), parseInt(arr[3]) - 8, parseInt(arr[4]), parseInt(arr[5])));
    const time = datum.getTime() / 1000;
    return time;
};
/**
 * 获取当月有几天
 * @param year 年
 * @param month 月
 * @returns  当前的天数
 */
export const piThGetMonthDay = (year, month) => {
    const days = new Date(year, month, 0).getDate();
    return days;
};
/**
 * 获取当前时间
 * @param type  时间格式 yyyy-MM-dd HH:MM:SS
 * @param dateObj 传入就是格式化传入的时间 New Date('xxx')
 * @returns string 时间
 */
export const piThThisTimes = (type, dateObj) => {
    const d = dateObj || new Date();
    let y = d.getFullYear();
    let m = d.getMonth() + 1;
    let dd = d.getDate();
    const day = d.getDay(); // 星期几
    let h = d.getHours(); // 时
    let f = d.getMinutes(); // 分
    let s = d.getSeconds(); // 秒
    y = y < 10 ? "0" + y : y;
    m = m < 10 ? "0" + m : m;
    h = h < 10 ? "0" + h : h;
    dd = dd < 10 ? "0" + dd : dd;
    f = f < 10 ? "0" + f : f;
    s = s < 10 ? "0" + s : s;
    let json = "";
    let yy = "";
    const dayObj = {
        "0": i18n.t("timeObj.0"),
        "1": i18n.t("timeObj.1"),
        "2": i18n.t("timeObj.2"),
        "3": i18n.t("timeObj.3"),
        "4": i18n.t("timeObj.4"),
        "5": i18n.t("timeObj.5"),
        "6": i18n.t("timeObj.6"),
    };
    let text = "";
    switch (type) {
        case "yy":
            json = y;
            break;
        case "mm":
            json = m;
            break;
        case "dd":
            json = dd;
            break;
        case "hh":
            json = h;
            break;
        case "ff":
            json = f;
            break;
        case "ss":
            json = s;
            break;
        case "day":
            json = day;
            break;
        case "days":
            json = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
            break;
        case "yyyy":
            json = y;
            break;
        case "yyyy-MM":
            json = y + "-" + m;
            break;
        case "yyyy-MM-s":
            yy = y + "";
            yy = yy.substring(yy.length - 3, yy.length - 1);
            json = yy + "-" + m;
            break;
        case "yyyy-MM-dd":
            json = y + "-" + m + "-" + dd;
            break;
        case "yyyy-MM-dd HH:MM":
            json = y + "-" + m + "-" + dd + " " + h + ":" + f;
            break;
        case "yyyy-MM-dd HH:MM:SS":
            json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
            break;
        case "HH:MM":
            json = h + ":" + f;
            break;
        case "HH:MM:SS":
            json = h + ":" + f + ":" + s;
            break;
        case "allTime":
            if (h < 9) {
                text = i18n.t("timeObj.earlyMorning") + "";
            }
            else if (h < 12) {
                text = i18n.t("timeObj.morning") + "";
            }
            else if (h < 14) {
                text = i18n.t("timeObj.noon") + "";
            }
            else if (h < 17) {
                text = i18n.t("timeObj.afternoon") + "";
            }
            else if (h < 19) {
                text = i18n.t("timeObj.night") + "";
            }
            json =
                y +
                    "-" +
                    m +
                    "-" +
                    dd +
                    " " +
                    dayObj[day] +
                    " " +
                    text +
                    " " +
                    h +
                    ":" +
                    f +
                    ":" +
                    s;
            break;
        default:
            json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
            break;
    }
    return json + "";
};
/**
 * date 转时间格式 HH:MM:SS
 * @param uData Date
 * @param type HH:MM:SS
 * @returns HH:MM:SS
 */
export const piThUserDate = (uData, type) => {
    const myDate = new Date(uData);
    const year = piThTimeZore(myDate.getFullYear());
    const month = piThTimeZore(myDate.getMonth() + 1);
    const day = piThTimeZore(myDate.getDate());
    const hours = piThTimeZore(myDate.getHours());
    const minutes = piThTimeZore(myDate.getMinutes());
    const second = piThTimeZore(myDate.getSeconds());
    if (type === "yyyy") {
        return year + "";
    }
    else if (type === "yyyy-MM") {
        return year + "-" + month;
    }
    else if (type === "yyyy-MM-dd") {
        return year + "-" + month + "-" + day;
    }
    else if (type === "HH:MM") {
        return hours + ":" + minutes;
    }
    else if (type === "HH:MM:SS") {
        return hours + ":" + minutes + ":" + second;
    }
    else {
        return (year +
            "-" +
            month +
            "-" +
            day +
            " " +
            hours +
            ":" +
            minutes +
            ":" +
            second);
    }
};
/**
 * 小于 10 的时间补0
 * @param time 1
 * @returns  01
 */
export const piThTimeZore = (time) => {
    if (time < 10) {
        return "0" + time;
    }
    else {
        return time + "";
    }
};
/**
 * 获取上一个月的今天
 * @param date  xxxx-xx-xx
 * @returns xxxx-xx-xx
 */
export const piThGetPreMonth = (date) => {
    const arr = date.split("-");
    const year = parseInt(arr[0]); //获取当前日期的年份
    const month = parseInt(arr[1]); //获取当前日期的月份
    const day = parseInt(arr[2]); //获取当前日期的日
    // const days = new Date(year, month, 0).getDate(); //获取当前日期中月的天数
    let year2 = year;
    let month2 = month - 1;
    if (month2 == 0) {
        year2 = year2 - 1;
        month2 = 12;
    }
    let day2 = day;
    // const days2 = new Date(year2, month2, 0);
    const days2 = new Date(year2, month2, 0).getDate();
    if (day2 > days2) {
        day2 = days2;
    }
    let m = month2 + "";
    if (month2 < 10) {
        m = "0" + month2;
        // month2 = "0" + month2;
    }
    let d = day2 + "";
    if (day2 < 10) {
        d = "0" + day2;
    }
    const t2 = year2 + "-" + m + "-" + d;
    return t2;
};
/**
 * 获取当前 n 个月前的时间
 * @param n  数字
 * @param dateObj   new Date() 不传就是当时间
 * @returns  xxxx-xx
 */
export const piThGetBeforeTime = (n, dateObj) => {
    const date = dateObj || new Date();
    date.setMonth(date.getMonth() - n);
    date.toLocaleDateString();
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    return y + "-" + piThTimeZore(m);
};
/**
 * 获取  N 天后的日期
 * @param AddDayCount  负就是 N天前，正就是 N天后
 * @param dateObj   new Date() 不传就是当时间
 * @returns xxxx-xx-xx
 */
export const piThGetDateStr = (AddDayCount, dateObj) => {
    const dd = dateObj || new Date();
    dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
    const y = dd.getFullYear();
    const m = dd.getMonth() + 1; //获取当前月份的日期
    const d = dd.getDate();
    return y + "-" + piThTimeZore(m) + "-" + piThTimeZore(d);
};
/**
 * 获取当前日期是星期几
 * @param date xxxx-xx-xx
 * @returns 0~6
 */
export const piThGetDateWeek = (date) => {
    const arr = date.split("-");
    const year = parseInt(arr[0]); //获取当前日期的年份
    const month = parseInt(arr[1]); //获取当前日期的月份
    const day = parseInt(arr[2]); //获取当前日期的日
    const tmpdate = new Date(year, month - 1, day);
    const whichWeek = tmpdate.getDay();
    return whichWeek;
};
/**
 * 对比开始时间和结束时间大小是否正确
 * @param start 开始时间 xxxx-xx-xx
 * @param end   结束时间 xxxx-xx-xx
 * @returns boolean  正确 true
 */
export const piThStartEndTime = (start, end) => {
    if (start != "" && end != "") {
        if (start.split(" ").length == 1) {
            start = start + " 00:00:00";
        }
        if (end.split(" ").length == 1) {
            end = end + " 23:59:59";
        }
        const startTime = piThTimeStrto(start);
        const endTime = piThTimeStrto(end);
        if (endTime > startTime) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return true;
    }
};
/**
 * 把例如1230转为12:30
 * @param data 1230
 * @param 12:30
 */
export const piThConvertStringToTimes = (data) => {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
};
/**
 * 把例如12:30转换为1230
 * @param data 12:30
 * @param 1230
 */
export const piThConvertTimesToString = (data) => {
    const times = data.split(":");
    const str = Number(times[0]) * 100 + Number(times[1]);
    return str;
};
